package game.entity

import game.Game
import game.Room

class TestBox: Enemy(3, 0) {
    override val deathSound: String = "enemy-explode"

    override fun onInit(game: Game, room: Room) {
        width = 3
        height = 3
        sprite = game.getSpriteById("test-box")
    }
}
